import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'cta' | 'ghost' | 'outline' | 'danger';
  size?: 'xs' | 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}

export const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  size = 'md',
  isLoading, 
  className = '', 
  disabled,
  ...props 
}) => {
  const baseStyles = "rounded-xl font-medium transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed transform active:scale-[0.97] focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-offset-bg dark:focus:ring-offset-darkBg focus:ring-primary/50 relative overflow-hidden tracking-tight";
  
  const variants = {
    // Gradiente Teal Moderno
    primary: "bg-primary hover:bg-primary-dark text-white shadow-sm hover:shadow-md border border-transparent",
    
    // Gradiente Azul Profundo (Navy)
    secondary: "bg-secondary hover:bg-secondary-light text-white shadow-sm hover:shadow-md border border-transparent",
    
    // Gradiente Pêssego/Laranja
    cta: "bg-cta hover:bg-cta-hover text-white shadow-sm hover:shadow-md border border-transparent",
    
    // Transparente com efeito hover refinado
    ghost: "bg-transparent text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800/50",
    
    // Borda fina
    outline: "bg-transparent border border-slate-200 dark:border-darkBorder text-slate-600 dark:text-slate-300 hover:border-primary hover:text-primary dark:hover:text-primary dark:hover:border-primary bg-white dark:bg-transparent",

    // Danger
    danger: "bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 border border-red-100 dark:border-red-800 hover:bg-red-100 dark:hover:bg-red-900/40"
  };

  const sizes = {
    xs: "px-3 py-1.5 text-xs",
    sm: "px-4 py-2 text-xs font-semibold",
    md: "px-5 py-2.5 text-sm",
    lg: "px-8 py-3 text-base",
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <>
          <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin absolute" />
          <span className="opacity-0">{children}</span> 
        </>
      ) : children}
    </button>
  );
};